export default class CodeCustomCreation {
  projectId = ""
  lot = ""
  sousLot = ""
  description = ""
  name = ""
  projectOrganizationId = ""
  parentCode = ""
}
